import { useEffect } from 'react'
import { ResurrectionCampaign } from './useResurrectionCampaign'

/**
 * Interface for the actions object that contains API methods
 */
interface Actions {
  getFeaturedMeals: (params: {
    attrs: { mealIds: number[] }
    source: string
  }) => void
}

/**
 * Custom hook to fetch featured meals based on resurrection campaign data
 *
 * @param resurrectionCampaign - The campaign data containing meal IDs
 * @param isFromLogin - Whether user is coming from login flow
 * @param actions - Actions object containing API methods
 */
export function useFeaturedMeals(
  resurrectionCampaign: ResurrectionCampaign | undefined,
  isFromLogin: boolean,
  actions: Actions
) {
  useEffect(() => {
    if (
      !isFromLogin &&
      resurrectionCampaign &&
      Array.isArray(resurrectionCampaign.highlightedMealsIds) &&
      resurrectionCampaign.highlightedMealsIds.length > 0
    ) {
      actions.getFeaturedMeals({
        attrs: { mealIds: resurrectionCampaign.highlightedMealsIds },
        source: 'STATIC'
      })
    }
  }, [resurrectionCampaign, actions, isFromLogin])
}
